<template>
  <v-row >
    <v-col cols="12" md="6">
      <ResultContinueBonus v-if="campaign.is_continue_bonus && campaignUser.course" :campaignUser="campaignUser"/>
      <ResultUserInfo v-if="!campaign.is_continue_bonus" :campaignUser="campaignUser"/>
      <WalkingTravel v-if="campaignOption.is_walking_travel && isSelectedWalkingCourse"
        :numberOfSteps="numberOfSteps" :firstGoalSequence="Number(18)"
      />
    </v-col>
    <v-col cols="12" md="6" style="margin:auto">
      <v-carousel
        cycle
        height="200"
        hide-delimiters
      >
        <template v-slot:prev="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">mdi-chevron-left</v-icon>
        </template>
        <template v-slot:next="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
        </template>
        <v-carousel-item v-for="image of dailyImageList" :key="image" style="text-align: center">
          <v-img :src="image" contain max-height="200" max-width="100vw"/>
        </v-carousel-item>
      </v-carousel>
    </v-col>
    <v-col cols="12" style="margin:auto" v-if="showAppStatusInfo">
      <AppStatus :appStatus="appEntryStatus"/>
    </v-col>
  </v-row>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import dayjs from 'dayjs'
const AppStatus = () => import('../app/AppStatus')
const ResultContinueBonus = () => import('./ResultContinueBonus')
const ResultUserInfo = () => import('./ResultUserInfo')
const WalkingTravel = () => import('./WalkingTravel')

const checkAppUserStatusQuery = (campaignId) => `
  query checkAppUserStatus {
    checkAppUserStatus (campaign_id: "${campaignId}")
  }
`
const checkAppUserStatus = async (campaignId) => {
  const { data: { checkAppUserStatus: data } } = await GraphqlAPI(checkAppUserStatusQuery(campaignId))
  return data
}

export default {
  name: 'resultTopic',
  data () {
    return {
      dailyImageList: [],
      participants: '',
      myRank: '',
      isCampaignPeriod: false,
      showAppStatusInfo: false
    }
  },
  props: ['campaignUser', 'isSelectedWalkingCourse', 'dailyValueList', 'numberOfSteps'],
  components: {
    AppStatus,
    ResultContinueBonus,
    ResultUserInfo,
    WalkingTravel
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    campaignOption () {
      return this.$store.getters.getCampaignOption
    },
    appEntryStatus () {
      return this.$store.getters.getAppEntryStatus
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    if (this.campaign.is_app_challenge && this.$store.getters.getAppEntryStatus === null) {
      this.featchAppEntryStatus()
    }
    // 画像の取得 61日＠3枚=183枚の画像が用意されている前提
    const targetNum = dayjs().diff(dayjs(new Date(this.campaign.site_open)), 'days') + 1
    const showNum = 3
    for (let i = showNum - 1; i >= 0; i--) {
      const imageNum = this.checkImageNum(targetNum * showNum - i)
      this.dailyImageList.push('/image/daily_image/' + imageNum + '_Daily.png')
    }

    // キャンペーン期間中か
    const startDate = dayjs(this.campaign.start, 'YYYY-MM-DD')
    const siteClose = dayjs(this.campaign.site_close, 'YYYY-MM-DD').add(1, 'days')
    this.isCampaignPeriod = dayjs() >= startDate && dayjs() < siteClose

    // アプリチャレンジステータス表示するか
    // キャンセルステータスの場合、コース変更可能期間後は、ここには表示しない
    if (this.campaign.is_app_challenge) {
      const courseDeletableEnd = dayjs(this.campaign.course_deletable_end, 'YYYY-MM-DD').add(1, 'days')
      const isCourseChangeablePeriod = dayjs() < courseDeletableEnd
      this.showAppStatusInfo = this.appEntryStatus && this.appEntryStatus !== 'Unregistered' && !(!isCourseChangeablePeriod && (this.appEntryStatus === 'Canceled' || this.appEntryStatus === 'Expired'))
    }
  },
  methods: {
    async featchAppEntryStatus () {
      try {
        const appEntryStatus = await checkAppUserStatus(this.campaign.id)
        this.$store.dispatch('setAppEntryStatus', appEntryStatus)
      } catch (e) {
        this.$log.debug(e)
      }
    },
    checkImageNum (num) {
      // 183の画像をループするため
      if (num > 183) {
        return this.checkImageNum(num - 183)
      }
      return num
    }
  }
}
</script>
